// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "리뷰",
    "note": "*이 리뷰의 모든 통계는 2025/12/31 기준입니다."
  },
  "handCard": {
    "text": "{date}\n2025년에 최초로 KKPoker를 플레이했습니다."
  },
  "report": {
    "loginTime": "그 후 KKPoker가 \n{loginDay}\n함께했습니다.",
    "loginTips": "*2025년에 KKPoker에 로그인한 일수입니다.",
    "enjoyTime": "{loginTime}\n하루 중 가장 즐거운 시간입니다. 이 시간 무렵에 KKPoker를 가장 많이 실행했습니다!",
    "firstHandDate": "{first_hand_date}\n{first_hand_type} 플레이 중에 올해의 첫 핸드를 받았습니다.\n{first_hand_cards}"
  },
  "hands": {
    "v1": "올해 KKPoker에서의 총 플레이 핸드:\n{hands}\n당신은 {percentage}의 플레이어보다\n포커를 더 사랑하는 분입니다.",
    "v2": "올해 KKPoker에서의 총 플레이 핸드:\n{hands}\n여정에 참여해 주셔서 감사합니다!",
    "v3": "올해 KKPoker에서의 총 플레이 핸드:\n{hands}\n다가올 한 해도 KKPoker에서 훨씬 더 큰 즐거움을 드리도록 노력하겠습니다"
  },
  "hardTime": {
    "date": "{one_day_hands}\n올해 KKPoker에 가장 헌신한 날입니다.",
    "hands": "이날 당신은 총 \n{one_day_hands_num}{longHands}\n플레이했습니다."
  },
  "favoriteGame": "총 핸드 수에서\n{handsNum}{hands} 가장 좋아하는 게임 포맷에서 플레이했습니다: {game}",
  "kkWin": {
    "v1": "2025년 KK 달성 횟수\n{all}{longTimes}\nKK로 상대를 이긴 횟수\n{win}{longTimesTwo}",
    "v2": "올해 올인 횟수\n{all}{threeTimes}\n올인 승률:\n{percentage}\n포커는 용기가 필요한 게임입니다!"
  },
  "achievement": {
    "spinup": "{spinup_date}\n가장 운 좋았던 날입니다.",
    "spinup_2": "이날 스핀업에서 {spinup_ratio}배수를 달성해 다음과 같은 수익을 냈습니다:\n{spinup_reward}",
    "mtt": "{mtt_date}\n올해의 하이라이트입니다.",
    "mtt_2": "그 날,\n{mtt_name}에서 {mtt_rank}위를 달성하고\n보상으로\n{mtt_reward}을(를) 획득했습니다",
    "rg": "{rg_date}\n포커 여정에서 기억에 남을 날입니다!",
    "rg_2": "이날 올해 당신의 가장 큰 팟을 따냈습니다:\n{rg_reward}"
  },
  "lucky": {
    "title": "모든 핸드에는 다른 \n이야기가 있습니다.",
    "luckyHand": "행운의\n핸드",
    "unLuckyHand": "불운의\n핸드",
    "luckyRate": "승리 확률\n{lucky_rate}",
    "unLuckyRate": "승리 확률\n{unlucky_rate}",
    "luckyText": "{lucky_hand}이(가) 영웅을 플레이했습니다. \n영웅과 함께했을 때 {lucky_rate}의 승률을 기록했습니다!",
    "unLuckyText": "{unlucky_hand}을(를) 지켜보세요…\n해당 카드와 함께 {unlucky_rate}의 승률만 기록했습니다.",
    "note": "*10회 이상 배분된 시작 핸드만 유효합니다."
  },
  "futureStory": "KKPoker는 2026년에도 여러분과 포커 여정의 이야기를 계속해서 써내려가고 싶습니다.",
  "version3": {
    "text": "죄송합니다, 2025년에서 KKPoker에서 추억을 남기지 않았습니다.",
    "continue": "2026년에는 KKPoker의\n다음 이야기를 써주세요!",
    "tips": " *모든 통계는 2024년 12월 31일 기준입니다."
  },
  "button": {
    "save": "이미지 저장",
    "copy": "복사 및 공유"
  },
  "unit": {
    "days": "일을",
    "hands": "핸드를",
    "longHands": "핸드를",
    "longTimes": "번",
    "longTimesTwo": "번",
    "threeTimes": "번",
    "times": "번",
    "multiplier": "배수를",
    "num": "",
    "num2": "",
    "bets": "번",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "링크 복사됨",
    "imageSaved": "이미지 저장됨"
  }
}
  